<template>
    <div :id='id' class="popup shadow-lg">
        <div class='container' style="height: 100%;">
            <div class='row' style="height: 100%">
                <div class="col-1 border-radius-left" :class="{ statusPending: this.status == 0, statusRejected: this.status == 2, statusAccepted: this.status == 3 }">
                </div>
                <div class='col'>
                    <div class='row' style="height: 100px;">
                        <div class='row col-12 pr-1'>
                            <div class='col-xl-6 col-lg-4 col-10'>
                                <h4 class='text-left mt-2 popup-header font-weight-bold'>{{ absence.type }}</h4>
                            </div>
                            <div class="cross-icon col-1 h2 pt-2 small-screen" @click="close()">
                                <i id='cross' class='fas fa-times text-muted' :value='absence.range_id'></i>
                            </div>
                            <div class='xl:w-5/12 lg:w-7/12 w-full mb-3 mt-2 text-left'>
                                <span class='mt-2'>{{ headerText }}</span>
                            </div>
                            <div class="cross-icon w-1/12 h2 pt-2 big-screen" :class="classes" @click="close()">
                                <i id='cross' class='fas fa-times text-muted' :value='absence.range_id'></i>
                            </div>
                        </div>
                        <div class='flex'>
                            <div class='w-full ml-2 text-left font-italic'>
                                <p>{{ absence.explanation }}</p>
                            </div>
                        </div>
                    </div>
                    <div class='flex bg-secondary pt-2 mt-4 popup-grey'>
                        <div class='xl:w-5/12 lg:w-7/12 w-full'>
                            <h5 class='text-left'>Status</h5>
                            <input type='hidden' id='absence' :value='absence.absence_id'/>
                            <input type='hidden' id='range' :value='absence.range_id'/>
                            <select v-model="status" class='form-control custom-select status-select' @change="statusChange" :disabled="!employer">
                                <option v-for="(status) in statusses" v-bind:key="status.text" :value='status.value' :selected="status.value == absence.status" >{{ status.text }}</option>
                            </select>
                        </div>
                        <div class='xl:w-7/12 lg:w-7/12 w-full'>
                            <div class='flex pl-3 pr-2'>
                                <h6 class='text-left'>Uren van dit verlof niet doorrekenen
                                    <div style="display: inline-block;">
                                        <div class="info-circle-wrap" @mouseenter="explainShow" @mouseout="explainHide">
                                            <div class="info-circle" @mouseenter="explainShow">
                                                <span class="info-text" @mouseenter="explainShow">?</span>
                                            </div>
                                        </div>
                                        <div class="info-pop-up-wrap rounded" v-show="explain">
                                            <div class="info-pop-up">
                                                <p class="mb-0">
                                                    Als verlof niet wordt doorgerekend, betekent dit dat het aantal verlofdagen dat is opgenomen niet wordt afgetrokken van het totale aantal verlofdagen. Dit kan voorkomen bij bijvoorbeeld verlof buiten de gebruikelijke verlofperiodes of extra verlofdagen als beloning, en kan worden geregistreerd als onbetaald verlof, compensatieverlof of verlof zonder inhouding.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </h6>
                            </div>
                            <div class='flex w-full'>
                                <div class='custom-control custom-switch custom-switch-lg ml-3' style='position: absolute;'>
                                    <input v-model="notCharged" type='checkbox' class='custom-control-input' style='z-index: 10; width: 95%; height: 33px; left: -13px;' :id='absence.range_id' @change="notChargingAbsence" :disabled="!employer"/>
                                    <label class='custom-control-label' :for='absence.range_id' ><small><i>Uren worden <b v-show="notCharged">niet</b> doorgerekend</i></small></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='flex overlapping'>
                        <div class='w-full mt-2 text-left' v-if="employer">
                            <p v-for="(overlap, index) in overlapping" :key="index" class="position-relative">
                                <b>Let op!</b> <i>{{ overlap[0] }} {{ overlap[1] }}</i> heeft al verlof, <br />
                                <b class="text-danger">Van {{ overlap[2] }} tot {{ overlap[3] }}</b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        components: {
            moment,
        },
        props: {
            absence: Object,
            viewType: Number,
            currentMonthYear: String,
            weeks: Array,
            employer: Boolean,
        },
        data: function () {
            return {
                statusses: [{ text: "Ingediend", value: 0 }, { text: "Goedgekeurd", value: 3 }, { text: "Afgekeurd", value: 2 }],
                id: "popup-" + this.absence.range_id,
                headerText: `${moment(this.absence.start_date).locale('nl').format('D MMMM')} ${this.absence.start_time} - ${moment(this.absence.end_date).locale('nl').format('D MMMM')} ${this.absence.end_time}`,
                firstTime: true,
                explain: false,
                notCharged: 0,
                overlapping: [],
                status: this.absence.status,
                windowWidth: window.innerWidth,
                classes: "",
            }
        },
        beforeMount() {
            this.classes = (this.windowWidth >= 1140) ? "pl-4" : "pl-3";
            window.addEventListener('click', this.clickEvent);
        },
        mounted() {
            this.status = this.absence.status;
            this.notCharged = this.absence.notcharged;

            this.checkOverlap();
        },
        watch: {
            absence: {
                handler: function (data) {
                    this.status = (this.status != data.status) ? data.status : this.status;
                    this.notCharged = (this.notCharged != data.notcharged) ? data.notcharged : this.notCharged;
                },
                deep: true,
            }
        },
        methods: {
            /**
             *
             * Checks
             *
             */
            checkPopup() {
                let lastWeekOfView = moment(this.currentMonthYear).locale('nl').endOf('month').week();
                let startWeek = moment(this.absence.start_date).locale('nl').week();
                let endWeek = moment(this.absence.end_date).locale('nl').week();
                let startWeekDate = moment(this.absence.start_date).locale('nl').endOf('week').format('Y-MM-DD');

                let allow = false

                if (this.viewType == 0) {
                    if (this.absence.view_type == 3 && (startWeek == lastWeekOfView || startWeek == moment().locale('nl').week(lastWeekOfView).subtract(1, 'weeks').week())) {
                        allow = true;
                    } else if (startWeek == lastWeekOfView && endWeek == lastWeekOfView) {
                        allow = true;
                    }
                } else if (this.viewType == 1 && (startWeekDate == weekEndDate || startWeekDate == moment(weekEndDate).locale('nl').subtract(1, 'days'))) {
                    allow = true
                }

                return allow;
            },
            checkOverlap() {
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `/absences/calendar/overlap`,
                    data:{
                        id: this.absence.profile_id,
                        start: this.absence.start_date,
                        end: this.absence.end_date,
                    },
                    success: this.callBackOverlap,
                });
            },
            /**
             *
             * Events
             *
             */
            clickEvent(event) {
                const popup = event.target.closest('.popup');

                // If no popup is clicked
                if (popup == null & !this.firstTime && !$('#warning_popup').is(':visible')) {
                    // Close all popups
                    this.close();
                }
                this.firstTime = false;
            },
            close() {
                this.$emit('close');
                window.removeEventListener('click', this.clickEvent);
            },
            statusChange() {
                this.$emit('warningStatus', this.status, this.absence.absence_id);
            },
            notChargingAbsence() {
                this.$emit('warningNotCharged', Number(this.notCharged), this.absence.absence_id);
            },
            /**
             *
             * Hover explanation
             *
             */
            explainShow() {
                this.explain = true;
            },
            explainHide() {
                this.explain = false;
            },
            /**
             *
             * Callbacks
             *
             */
            callBackNotCharging(event) {
                this.$emit('notChargingChange', Number(event.notCharged));
            },
            callBackOverlap(event) {
                event.overlap.forEach((overlap) => {
                    this.overlapping.push([overlap.first_name, overlap.surname, moment(overlap.start_date).locale('nl').format('D MMMM'), moment(overlap.end_date).locale('nl').format('D MMMM')])
                });
            }
        }
    }
</script>
